import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Subject } from 'rxjs';
import { Alert, AlertType } from './../alert/alert';
import { NavigationStart, Router } from '@angular/router';

@Injectable({
	providedIn: 'root',
})
export class AlertService {
	constructor(private router: Router) {
		// clear alert messages on route change unless 'keepAfterRouteChange' flag is true
		router.events.subscribe((event) => {
			if (event instanceof NavigationStart) {
				if (this.keepAfterRouteChange) {
					// only keep for a single route change
					this.keepAfterRouteChange = false;
				} else {
					// clear alert messages
					this.clear();
				}
			}
		});
	}

	private keepAfterRouteChange = false;
	private subject = new Subject<Alert>();

	public alert(type: AlertType, message: string, keepAfterRouteChange = false): void {
		this.keepAfterRouteChange = keepAfterRouteChange;
		this.subject.next({ type, message } as Alert);
	}

	public clear(): void {
		// clear alerts
		this.subject.next(undefined as unknown as Alert);
	}

	public error(message: string, keepAfterRouteChange = false): void {
		this.alert(AlertType.Error, message, keepAfterRouteChange);
	}

	public getAlert(): Observable<Alert> {
		return this.subject.asObservable();
	}

	public info(message: string, keepAfterRouteChange = false): void {
		this.alert(AlertType.Info, message, keepAfterRouteChange);
	}

	public success(message: string, keepAfterRouteChange = false): void {
		this.alert(AlertType.Success, message, keepAfterRouteChange);
	}

	public warn(message: string, keepAfterRouteChange = false): void {
		this.alert(AlertType.Warning, message, keepAfterRouteChange);
	}
}
